// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWrapper_container__34dLQ","pageWrapper":"PageWrapper_pageWrapper__1sJq1","page":"PageWrapper_page__1Xfr6","editorContent":"PageWrapper_editorContent__2R09J"};